export default __webpack_public_path__ + "static/studio-738e4366740a62da19d830cede86395c.webp";